import { DATES, DATES_ID } from 'services/constants/dates-constants';
import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { EServiceStatus, EServiceStatusID, TEudrItem } from 'redux/reducers/eudr/types';
import { EEmEnums } from '../../redux/reducers/emManagement/constants';

// const SERVICE_STATUS_FILTER: [string | null, string][] = [
// 	[EServiceStatus.DISABLED, 'Disabled'],
// 	[EServiceStatus.REGISTERED, 'Registered'],
// 	[EServiceStatus.INVOICED, 'Invoiced'],
// ];

export const SERVICE_STATUS_ID_FILTER: [string | null, string][] = [
	[String(EServiceStatusID.DISABLED), EServiceStatus.DISABLED],
	[String(EServiceStatusID.REGISTERED), EServiceStatus.REGISTERED],
	[String(EServiceStatusID.INVOICED), EServiceStatus.INVOICED],
	[String(EServiceStatusID.NEW), EServiceStatus.NEW],
	[String(EServiceStatusID.CANCELLED), EServiceStatus.CANCELLED],
];

export const tableStructure: TTableStructure<keyof TEudrItem>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		key: true,
	},
	{
		name: 'EM ID',
		selector: 'emId',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.LINK,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Full Name',
		selector: 'fullName',
		show: true,
		searchable: true,
		sortable: true,
		filterable: false,
		showInFoolData: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'EORI',
		selector: 'eori',
		show: true,
		searchable: false,
		sortable: true,
		filterable: false,
		showInFoolData: true,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Service Status',
		selector: 'serviceStatusId',
		show: false,
		sortable: true,
		filterable: true,
		filter: SERVICE_STATUS_ID_FILTER,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Period Start',
		selector: 'periodStart',
		show: true,
		sortable: true,
		filterable: false,
		showInFoolData: true,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
		],
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Period End',
		selector: 'periodEnd',
		show: true,
		sortable: true,
		filterable: false,
		showInFoolData: true,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.TOMORROW, DATES.TOMORROW],
			[DATES_ID.NEXT_7_DAYS, DATES.NEXT_7_DAYS],
			[DATES_ID.NEXT_30_DAYS, DATES.NEXT_30_DAYS],
			[DATES_ID.NEXT_MONTH, DATES.NEXT_MONTH],
			[DATES_ID.NEXT_QUARTER, DATES.NEXT_QUARTER],
			[DATES_ID.NEXT_YEAR, DATES.NEXT_YEAR],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Actual Amount',
		selector: 'actualAmount',
		show: true,
		sortable: true,
		filterable: false,
		showInFoolData: true,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
		currency: () => 'EUR',
	},
	{
		name: 'Subscription Plan ID',
		selector: 'subscriptionPlanId',
		show: false,
		sortable: true,
		filterable: false,
		showInFoolData: true,
		colSpan: 1,
		type: ETableStructureType.ARRAY_ID,
		align: ETableStructureAlign.RIGHT,
		enumName: EEmEnums.EUDR_SUBSCRIPTION_PLAN,
	},
	{
		name: 'Subscription Plan Name',
		selector: 'subscriptionPlanName',
		show: true,
		sortable: true,
		filterable: false,
		showInFoolData: true,
		colSpan: 1,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Invoice ID',
		selector: 'invoiceId',
		show: true,
		sortable: true,
		filterable: false,
		showInFoolData: true,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Service Status',
		selector: 'serviceStatusName',
		show: true,
		sortable: true,
		filterable: false,
		showInFoolData: true,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colors: [
			[EServiceStatus.DISABLED, 'error.light'],
			[EServiceStatus.REGISTERED, 'primary.light'],
			[EServiceStatus.INVOICED, 'success.light'],
			[EServiceStatus.NEW, 'primary.light'],
			[EServiceStatus.CANCELLED, 'warning.light'],
		],
	},

	{
		name: 'Created At',
		selector: 'createdAt',
		show: true,
		sortable: true,
		filterable: true,
		showInFoolData: true,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
		],
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Author',
		selector: 'author',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Updated At',
		selector: 'updatedAt',
		show: true,
		sortable: true,
		filterable: true,
		showInFoolData: true,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
		],
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Updated By',
		selector: 'updatedBy',
		show: true,
		searchable: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Cancelled By',
		selector: 'cancelledBy',
		show: true,
		searchable: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Cancelled At',
		selector: 'cancelledAt',
		show: true,
		sortable: true,
		filterable: false,
		showInFoolData: true,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
		],
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
	},
];
